// extracted by mini-css-extract-plugin
var _1 = "pMzF0jWFcI";
export { _1 as "root" }
